import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

const Appear = {
  instances: new Map(),

  init() {
    // Use .appear for one node, .appear-children for a staggered group, and
    // .appear-lines on a group child (or by itself) for rendered text lines.
    document.querySelectorAll('.appear, .appear-children, .appear-lines').forEach(element => {
      if (this.instances.has(element) || element.closest('.editor-styles-wrapper') || element.closest('[data-coming-soon]')) return

      const parentGroup = element.parentElement?.closest('.appear-children')
      if (parentGroup) return

      const media = gsap.matchMedia()
      this.instances.set(element, media)
      media.add('(prefers-reduced-motion: no-preference)', () => this.create(element))
    })
  },

  create(group) {
    const elements = group.classList.contains('appear-children') ? Array.from(group.children) : [group]
    if (!elements.length) return

    const text = elements.filter(element => element.classList.contains('appear-lines'))
    let timeline
    let started = false
    let completed = false

    const animate = split => {
      if (completed) {
        timeline = gsap.timeline()

        return timeline
      }

      const targets = elements.flatMap(element => {
        if (!element.classList.contains('appear-lines')) return element

        const lines = split?.lines.filter(line => element.contains(line)) || []

        return lines.length ? lines : element
      })

      timeline = gsap.timeline({
        paused: !started,
        onComplete: () => {
          completed = true
        }
      })
      timeline.from(targets, {
        opacity: 0,
        y: 32,
        duration: 1.15,
        stagger: 0.09,
        ease: 'power4.out',
        lazy: false,
        clearProps: 'opacity,transform'
      })

      return timeline
    }

    const split = text.length ? SplitText.create(text, { type: 'lines', autoSplit: true, onSplit: animate }) : null
    if (!split) animate()

    const trigger = ScrollTrigger.create({
      trigger: group,
      start: 'top 90%',
      once: true,
      onEnter: () => {
        started = true
        timeline.play()
      }
    })
    const revealFocused = () => {
      started = true
      timeline.progress(1)
    }
    group.addEventListener('focusin', revealFocused)

    return () => {
      group.removeEventListener('focusin', revealFocused)
      trigger.kill()
      timeline.revert()
      split?.revert()
    }
  },

  destroy() {
    this.instances.forEach(media => media.revert())
    this.instances.clear()
  }
}

export default Appear
